/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { MSCLKID_LOCAL_STORAGE_KEY } from '../constants'
import type { LocalStorage } from '../types/LocalStorage'

const VALID_MSCLKID_REGEX = /^[\w-]{1,250}$/

export const getMsclkidFromLocalStorage = (ls: LocalStorage) => {
  const value = ls.getx(MSCLKID_LOCAL_STORAGE_KEY, 7)
  if (value && VALID_MSCLKID_REGEX.test(value)) {
    return value
  }
}
